<template>
  <div style="min-height: 100vh;">
    <v-text-field
      label=""
      ref="searchTextField"
      clearable
      hide-details
      class="secondary"
      single-line
      absolute
      aria-label="Søk"
      v-model="search"
      style="position: sticky;top: 0px; z-index: 100; "
      placeholder="Søk.."
      append-icon="chevron_left"
      @click:clear="clearSearch"
      :loading="updatingSources"
      clear-icon="mdi-close-circle-outline"
      @click:append="hide"
      box
    ></v-text-field>

    <v-list v-show="search !== null">
      <template v-for="(item, index) in items">
        <v-list-tile
          v-if="typeof item !== 'object'"
          :key="item.key"
          class="small-font"
          color="yellow"
        >
          <v-list-tile-content
            v-text="item"
            class="small-font"
          ></v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar :key="index" v-else @click="selectItem(item)">
          <v-list-tile-content>
            <v-list-tile-title
              :style="{
                color: select && item.key === select.key ? 'red' : '',
              }"
              v-html="item.text"
              >{{ item.sourceIndex }}</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>

    <v-fade-transition>
      <v-container fill-height>
        <v-layout
          v-show="!search"
          align-center
          justify-center
          column
          fill-height
          style="margin-left: 70px; margin-right: 70px;"
        >
          <v-icon style="font-size: 50px">search</v-icon>
          <label style="text-align: center"
            >Du kan søke etter stedsnavn, adresser, gårdsnr/bruksnr, og i
            kartlagene du har lagt til.</label
          >
        </v-layout>
      </v-container>
    </v-fade-transition>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
export default {
  name: "MapSearch",
  data: function() {
    return {
      searchViewModel: null,
      graphicsLayer: null,
      infoText: "Klikk i kartet for å starte måling",
      loaded: false,
      fab: false,
      model: null,
      selectedTool: "",
      toggle_exclusive: 0,
      selectedColor: "blue",
      loading: false,
      items: [],
      search: null,
      select: null,
      menuProps: {
        closeOnClick: false,
        closeOnContentClick: false,
      },
      currentlySearchableProfiles: [],
      states: [],
      autoselectMenu: false,
      updatingSources: false,
    };
  },
  mixins: [MappingMixin],
  watch: {
    search(val) {
      if (val == "") {
        this.items = [];
      }

      val && val !== this.select && this.querySelections(val);
    },
    activeExclusiveToolName(newVal, oldVal) {
      if (newVal !== oldVal && newVal === "search") {
        this.$nextTick(this.$refs.searchTextField.focus());
        this.updateSources(this.mapProfiles);
      }
    },
    mapProfiles(val) {
      if (this.activeExclusiveToolName === "search") {
        this.updateSources(val);
      }
    },
    is3d(val) {
      if (val) {
        this.searchViewModel.view = this.$theSceneViewObject;
      } else {
        this.searchViewModel.view = this.$theMapViewObject;
      }
    },
  },
  computed: {
    ...mapState(["mapProfiles", "activeExclusiveToolName", "is3d"]),
  },
  methods: {
    ...mapActions(["setShowSideMenu"]),
    selectItem(item) {
      this.select = item;
      if (item) {
        if (this.is3d) {
          this.searchViewModel.view = this.$theSceneViewObject;
        } else {
          this.searchViewModel.view = this.$theMapViewObject;
        }

        if (typeof item === "object") {
          this.searchViewModel.search(item);
        }
      }
    },
    getSearchFieldsFromQuery(searchSource) {
      if (!searchSource.hasOwnProperty("query")) {
        return [];
      }
      let query = searchSource.query.trim().split(" ");
      let searchFields = [];

      for (let i = 0; i < query.length; i++) {
        let queryString = query[i].toLowerCase();
        if (
          queryString == "'{searchtext}%'" ||
          queryString == "'{searchtext}'" ||
          queryString == "like" ||
          queryString == "or"
        ) {
          continue;
        }
        searchFields.push(query[i]);
      }
      return searchFields;
    },
    updateSources(profiles) {
      loadModules(["esri/layers/FeatureLayer"]).then(([FeatureLayer]) => {
        this.updatingSources = true;

        for (let i = this.currentlySearchableProfiles.length - 1; i >= 0; i--) {
          let currentlySearchableProfile = this.currentlySearchableProfiles[i];
          let currentlySearchableProfileIndex = i;
          let existingSources = this.searchViewModel.sources.filter(
            (source) => {
              return (
                source.hasOwnProperty("layer") &&
                source.layer.id.includes("search" + currentlySearchableProfile)
              );
            }
          );
          if (existingSources.length > 0) {
            existingSources.forEach((source) => {
              this.searchViewModel.sources.remove(source);
            });
            this.currentlySearchableProfiles.splice(
              currentlySearchableProfileIndex,
              1
            );
          }
        }
        profiles.forEach((addedProfile) => {
          if (
            this.searchViewModel &&
            addedProfile.visible &&
            addedProfile.Search &&
            addedProfile.Search.mapServiceSearch &&
            !this.currentlySearchableProfiles.includes(addedProfile.id)
          ) {
            addedProfile.Search.mapServiceSearch.forEach(
              (mapServiceSearchSource, mapServiceSearchSourceIndex) => {
                let searchFields = mapServiceSearchSource.hasOwnProperty(
                  "searchFields"
                )
                  ? mapServiceSearchSource.searchFields
                  : this.getSearchFieldsFromQuery(mapServiceSearchSource);

                let source = {
                  layer: new FeatureLayer({
                    url: mapServiceSearchSource.queryUrl,
                    id:
                      "search" + addedProfile.id + mapServiceSearchSourceIndex,
                    outFields: ["*"],
                  }),
                  resultSymbol: this.getDefaultHighlightSymbol(
                    this.$theMapViewObject
                  ),
                  searchFields: searchFields,
                  displayField: mapServiceSearchSource.valueField,
                  suggestionTemplate: mapServiceSearchSource.suggestionTemplate,

                  exactMatch: false,
                  outFields: ["*"],
                  name: mapServiceSearchSource.type,
                  suggestionsEnabled: true,
                  maxResults: 100,
                  maxSuggestions: 100,
                };

                this.searchViewModel.sources.push(source);
              }
            );
            this.currentlySearchableProfiles.push(addedProfile.id);
          }
        });

        this.updatingSources = false;
      });
    },
    querySelections(v) {
      this.loading = true;
      this.searchViewModel.suggest(v);
    },

    clearSearch: function() {
      this.autoselectMenu = false;
      this.select = null;
      this.search = null;
      this.items = [];
      this.searchViewModel.clear();
    },
    performSearch: function() {
      this.searchViewModel.search(this.search);
    },
    hide: function() {
      this.setShowSideMenu(false);
    },
    loadSearch: function() {
      loadModules([
        "esri/widgets/Search/SearchViewModel",

        "esri/tasks/Locator",
        "esri/config",
        "esri/core/urlUtils",
      ]).then(
        function([SearchViewModel, Locator, esriConfig, urlUtils]) {
          urlUtils.addProxyRule({
            urlPrefix: process.env.VUE_APP_ADDRESS_SEARCH_LOCATOR_URL,
            proxyUrl: process.env.VUE_APP_PROXY_URL,
          });
          esriConfig.request.proxyUrl = process.env.VUE_APP_PROXY_URL;

          this.searchViewModel = new SearchViewModel({
            view: this.$theMapViewObject,
            popupEnabled: false,
            resultGraphicEnabled: true,
            includeDefaultSources: false,
            resultSymbol: this.getDefaultHighlightSymbol(
              this.$theMapViewObject
            ),
            suggestionDelay: 150,
            maxResults: 100,
            maxSuggestions: 100,
            sources: [
              {
                locator: new Locator(
                  process.env.VUE_APP_ADDRESS_SEARCH_LOCATOR_URL
                ),
                singleLineFieldName: "SingleLine",
                placeholder: "Adresse",
                maxLocations: 100,
                name: "Stedsnavn/adresser",
              },
            ],
            goToOverride: function(view, goToParams) {
              let params = {
                target: goToParams.target.target,
              };

              if (
                goToParams.target.target.hasOwnProperty("attributes") &&
                goToParams.target.target.attributes.hasOwnProperty("Addr_type")
              ) {
                params.zoom = 15;
              }
            },
          });

          //

          this.searchViewModel.on("suggest-complete", (event) => {
            if (event.searchTerm !== this.search) {
              if (this.search == null || this.search === "") {
                this.loading = false;
              }
              return;
            }

            this.loading = false;

            if (event.numResults !== 0) {
              this.autoselectMenu = true;
            }

            this.items = [];

            event.results.forEach((result, index) => {
              if (result.results.length > 0) {
                this.items.push(
                  this.searchViewModel.allSources.items[index].name
                );
              }

              for (let i = 0; i < result.results.length; i++) {
                let arrayItem = result.results[i];

                this.items.push(arrayItem);
              }

              if (this.search == "") {
                this.items = [];
              }
            });
          });

          this.searchViewModel.on(
            "search-complete",
            function(evt) {
              this.loading = false;
              let gotoTargetGeometry =
                evt.results[0].results[0].feature.geometry;
              let gotoTarget = {
                target: gotoTargetGeometry,
              };
              if (gotoTargetGeometry.type === "point") {
                gotoTarget.zoom = 15;
              }
              if (this.is3d) {
                this.$theSceneViewObject.goTo(gotoTarget);
              } else {
                this.$theMapViewObject.goTo(gotoTarget);
              }

              if (this.$vuetify.breakpoint.smAndDown) {
                this.hide();
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
  },
  mounted() {
    this.loadSearch();
  },
};
</script>

<style>
.v-autocomplete__content.v-menu__content {
  max-width: 300px !important;
  max-height: calc(100% - 61px) !important;
  -webkit-box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.37);
  -moz-box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.37);
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.37);

  margin-right: 1px;
}

.group-header {
  background: #eeeeee;
}

.small-font {
  font-size: 12px !important;
  text-transform: uppercase;
}
</style>
